import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  MessagesState,
  Message,
  CallMessage,
  FlaggedResponse,
} from "../../pages/Communications/utils/types";

const initialState: MessagesState = {
  messages: [],
  averageAiResponseTime: 0,
  averageLeadResponseTime: 0,
  totalCost: 0,
  costCurrency: "",
  channel: "",
  flaggedResponses: undefined,
};

const messagesSlice = createSlice({
  name: "playgroundMessages",
  initialState,
  reducers: {
    setMessages: (
      state,
      action: PayloadAction<{
        inbox: Message[];
        average_ai_response_time: number;
        average_lead_response_time: number;
        total_cost: number;
        cost_currency: string;
        channel: string;
      }>
    ) => {
      state.messages = action.payload.inbox;
      state.averageAiResponseTime = action.payload.average_ai_response_time;
      state.averageLeadResponseTime = action.payload.average_lead_response_time;
      state.totalCost = action.payload.total_cost;
      state.costCurrency = action.payload.cost_currency;
      state.channel = action.payload.channel;
    },
    setFlagggedResponses: (state, action: PayloadAction<FlaggedResponse[]>) => {
      state.flaggedResponses = action.payload;
    },
    updateFlagggedResponses: (
      state,
      action: PayloadAction<FlaggedResponse>
    ) => {
      state.flaggedResponses = [
        ...(state.flaggedResponses || []),
        action.payload,
      ];
    },
    removeFlagggedResponse: (state, action: PayloadAction<string>) => {
      state.flaggedResponses = state.flaggedResponses?.filter(
        (response) => response.message_id !== action.payload
      );
    },
    clearFlagggedResponses: (state) => {
      state.flaggedResponses = [];
    },

    clearMessages: (state) => {
      state.messages = [];
      state.averageAiResponseTime = 0;
      state.averageLeadResponseTime = 0;
      state.totalCost = 0;
      state.costCurrency = "";
      state.channel = "";
      state.flaggedResponses = [];
    },
    appendMessage: (state, action: PayloadAction<Message>) => {
      const alreadyAppended = state.messages.find(
        (msg) => msg?.id === action?.payload?.id
      );
      if (!alreadyAppended) {
        state.messages.push(action.payload);
      }
    },
    replaceMessage: (state, action: PayloadAction<Message | CallMessage>) => {
      const message = action.payload as Message;
      const id = message?.role === "user" ? message?.secondary_id : message?.id;
      const index = state.messages.findIndex((msg) => msg.id === id);
      if (index !== -1) {
        state.messages[index] = message;
      } else {
        state.messages.push(message);
      }
    },
  },
});

export const {
  setMessages,
  clearMessages,
  replaceMessage,
  appendMessage,
  setFlagggedResponses,
  updateFlagggedResponses,
  clearFlagggedResponses,
  removeFlagggedResponse,
} = messagesSlice.actions;
export default messagesSlice;
